<template>
  <v-layout >
    <v-flex xs12 text-xs-left v-if="programs.length === 0" class="mt-5 pl-2"
    >
      <h4><strong>Store not found.</strong></h4>
    </v-flex>
    <v-layout column class="align-self-start mt-3" v-if="programs.length > 0">
      <v-layout>
        <v-flex xs7>
          <v-select
            v-model="selectedProgram"
            :items="programs"
            item-text="name"
            item-value="storeId"
            label="Store"
            :disabled="programs.length === 0"
          ></v-select>

        </v-flex>
        <v-flex xs5 text-xs-right>
          <v-btn
            @click="fetchReport"
            :disabled="groupedUsers.length === 0"
            outline color="primary" >
            <span class="notranslate"><v-icon v-if="!isXs">mail_outline</v-icon></span>&nbsp;&nbsp;Email Report
          </v-btn>
        </v-flex>
      </v-layout>

      <v-flex xs12 class="mt-2">
        <table class="table">
          <thead>
          <tr>
            <th @click="sortBy('firstName')" style="cursor: pointer">Team Member <v-icon
              :style="{fontSize: '18px', rotate: this.sortAsc ? '180deg' : '360deg'}">filter_list</v-icon></th>
            <th>Certificate</th>
            <th v-if="$vuetify.breakpoint.name !== 'xs'">Status</th>
            <th>Valid To</th>
          </tr>
          </thead>
          <tbody>
          <template v-for="(group, index) in sortedGroupedRecords"  >
            <tr v-for="(record, rIndex) in group.records" :key="record.userId + '-' + rIndex" :class="`group-${index % 2}`">
              <td v-if="rIndex === 0" :rowspan="group.records.length" style="vertical-align: middle;">
                <div class="align-content-center d-inline-flex">
                  <img width="20" :src="'https://api.cogneti.com/ws/playerservice/user/'+ group.userId +'/blob'" alt="" />
                  <span style="cursor: pointer;" class="ellipsis" >
                        &nbsp;&nbsp;{{ group.firstName }} {{ group.lastName }}
                      </span>
                </div>
              </td>
              <td>
                <a href="#" @click.stop="getSelectedUSer(record)">{{ record.certificate }}</a>
                <img v-if="record.otherCertificate"
                     src="@/assets/logos/user-up.svg" height="18" alt="user uploaded"/>
              </td>
              <td  v-if="$vuetify.breakpoint.name !== 'xs'">
                <strong class="notranslate "
                        :class="statusClass[record.progress.toLowerCase()]">{{ record.progress }}
                </strong></td>
              <td>
                <strong class="notranslate " v-if="$vuetify.breakpoint.name === 'xs'"
                        :class="statusClass[record.progress.toLowerCase()]">{{ record.progress }} <br>
                </strong>
                {{record.validTo ? new Date(record.validTo).toLocaleDateString('en-GB', {
                day : 'numeric',
                month : 'short',
                year : 'numeric'
              }).split(' ').join('-') : '-'}}
              </td>

            </tr>
          </template>
          </tbody>
        </table>
      </v-flex>

    </v-layout>

    <v-dialog v-model="imagePreviewSrc"
              v-if="imagePreviewSrc"
              width="500"
              transition="dialog-bottom-transition">
      <v-card>
        <v-card-text>
          <img :src="imagePreviewSrc" style="width: inherit" alt="Image Preview"/>
        </v-card-text>
        <v-card-actions>
          <v-btn dark flat
                 color="info"
                 @click="downloadImage(imagePreviewSrc, Date.now() + '.png')">
            <v-icon>cloud_download</v-icon>
            &nbsp;Download

          </v-btn>
          <v-spacer></v-spacer>
          <v-btn dark flat
                 color="error"
                 @click="imagePreviewSrc = ''">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>


    <v-dialog v-model="dialog" fullscreen hide-overlay transition="dialog-bottom-transition">
      <v-card>
        <v-flex class="gutter-mobile-header" style="background:#4a2dff;" />

        <v-layout align-center justify-center>
          <v-flex xs12 sm8>
        <v-card-title class="pa-0">

          <div style="cursor: pointer;" class="align-center d-inline-flex  primary--text title">
            <v-btn class="mr-0 ml-0" @click.stop="dialog=false" flat color="primary">&#8592; Back</v-btn>
          </div>

        </v-card-title>
        <v-divider class="mt-0"></v-divider>
        <v-card-text>
          <v-flex xs12 lg6 offset-lg3>
            <div style="height:30px" class="align-center d-flex font-weight-black justify-center primary white--text">
              {{ selectedMember.firstName }} {{ selectedMember.lastName }}
            </div>
            <table class="table">
              <tr>
                <td style="width:40%">User ID</td>
                <td style="width:60%">{{selectedMember.userId}}</td>
              </tr>
              <tr>
                <td>Email</td>
                <td><a title="send email" :href="`mailto:${selectedMember.email}`">{{selectedMember.email}}</a></td>
              </tr>
              <tr>
                <td>Certificate Type</td>
                <td>{{selectedMember.certificate}}</td>
              </tr>
              <tr>
                <td>License Date</td>
                <td>
                  {{selectedMember.licenseDate ? new Date(selectedMember.licenseDate).toLocaleDateString('en-GB', {
                  day : 'numeric',
                  month : 'short',
                  year : 'numeric'
                }).split(' ').join('-') : '-'}}

                </td>
              </tr>

              <tr>
                <td>Valid To</td>
                <td>
                  {{selectedMember.validTo ? new Date(selectedMember.validTo).toLocaleDateString('en-GB', {
                  day : 'numeric',
                  month : 'short',
                  year : 'numeric'
                }).split(' ').join('-') : '-'}}
                </td>
              </tr>

              <tr>
                <td>Status</td>
                <td>
                  <span class="notranslate">
                    <span :class="statusClass[selectedMember.progress.toLowerCase()]">
                      <strong>{{selectedMember.progress}}</strong>
                    </span>
                  </span>
                </td>
              </tr>

            </table>
          </v-flex>
          <v-flex  xs12 lg6 offset-lg3 class="text-xs-center"
                   v-if="['pending approval', 'valid'].includes(selectedMember.progress.toLowerCase())">
            <div><img class="elevation-10" v-if="frontImg"
                 style="height:150px;border-radius: 10px;"
                      @click="imagePreviewSrc = frontImg"
                      :src="frontImg"></div>
            <div><v-img class="pa-5" v-if="frontImg === ''">
              <v-progress-circular indeterminate color="blue lighten-2"></v-progress-circular>
            </v-img></div>

            <div><img class="elevation-10" v-if="backImg"
                 style="height:150px;border-radius: 10px;"
                      @click="imagePreviewSrc = backImg"
                      :src="backImg"></div>
            <v-form
              v-if="selectedMember.otherCertificate === false"
              ref="badgeEmailForm"
              v-model="badgeEmailFormValid"
              lazy-validation
            >
              <v-flex>

                <v-text-field
                  v-model="badgeEmails"
                  :rules="badgeEmailsRules"
                  label="Send badge to"
                  placeholder="bigz@example.com, manager@example.com"
                  required
                ></v-text-field>
              </v-flex>
              <v-flex>
                <v-btn @click="validateSendBadgeInEmail" :disabled="!badgeEmailFormValid || !badgeId"
                       :loading="loadingSendBadgeMail" block color="primary">Email Badge
                </v-btn>
                <v-btn color="primary" block :disabled="certificateMailSend  || !badgeId"
                       :loading="loadingSendCertificateMail"
                       @click="sendCertificateMail">Email Certificate
                </v-btn>
              </v-flex>
            </v-form>
          </v-flex>
        </v-card-text>
          </v-flex>
        </v-layout>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
  export default {
    name: 'ComplianceCenter',
    data: () => ({
      statusClass: {
        'valid': 'success--text',
        'licensed': '',
        'in-progress': 'primary--text',
        'registered': '',
        'expired': 'error--text'
      },
      imagePreviewSrc: '',
      imagePreviewDialog: '',
      apiUrl: process.env.API_URL,
      eventFormLoader: false,
      selectedParticipants: [],
      participants: [],
      timeMenu: false,
      dateMenu: false,
      eventHours: '',
      eventMinutes: 0,
      eventTime: null,
      eventDate: new Date().toISOString().substr(0, 10),
      eventLocation: '',
      eventDescription: '',
      eventName: '',
      eventType: '',
      eventTypes: ['Other'],
      validEventForm: true,
      recordEventDialog: false,
      loadingSendBadgeMail: false,
      certificateMailSend: false,
      loadingSendCertificateMail: false,
      badgeMailSend: false,
      badgeId: '',
      badgeEmails: '',
      badgeEmailsRules: [
        v => !!v || 'E-mail is required',
        v => /^$|^((\s?[^\s,]+@[^\s,]+\.[^\s,]+\s?,)*(\s?[^\s,]+@[^\s,]+\.[^\s,]+))$/g.test(v) || 'E-mail must be valid'
      ],
      badgeEmailFormValid: false,
      dialog: false,
      selectedProgram: '',
      frontImg: '',
      backImg: '',
      selectedUser: {},
      selectedMember: {
        progress: 'valid'
      },
      users: [],
      groupedUsers: [],
      serialNumber: 1,
      sortKey: '',
      sortAsc: true
    }),
    computed: {
      teamEmails () {
        return this.groupedUsers.map(user => user.email)
      },
      isXs () {
        return this.$vuetify.breakpoint.name === 'xs'
      },
      user () {
        return this.$store.getters['user/getUserDetails']
      },
      recordEventDialogHeader () {
        return [
          {
            text: 'Manager Actions',
            disabled: false,
            href: 'ComplianceCenter'
          },
          {
            text: 'Recording event by ' + this.recorder,
            disabled: true,
            href: ''
          }
        ]
      },
      recorder () {
        return this.$store.getters['user/getFirstName'] + ' ' + this.$store.getters['user/getLastName']
      },
      recorderId () {
        return this.$store.getters['user/getUserId']
      },
      programs () {
        return this.$store.getters['splatReport/getStores']
      },
      allParticipants () {
        return this.selectedParticipants.length === this.participants.length
      },
      someParticipants () {
        return this.selectedParticipants.length > 0 && !this.allParticipants
      },
      icon () {
        if (this.allParticipants) return 'mdi-close-box'
        if (this.someParticipants) return 'mdi-minus-box'
        return 'checkbox'
      },
      sortedGroupedRecords () {
        if (this.sortKey) {
          return this.groupedUsers.sort((a, b) => {
            let result = 0
            if (a[this.sortKey] < b[this.sortKey]) result = -1
            if (a[this.sortKey] > b[this.sortKey]) result = 1
            return this.sortAsc ? result : -result
          })
        }
        return this.groupedUsers
      }
    },
    created () {
      setTimeout(() => {
        this.$store.commit('setIsCompactHeader', false)
        this.selectedProgram = this.programs[0].storeId
        this.fetchProgram()
      }, 500)
    },
    methods: {
      getSortIcon (key) {
        if (this.sortKey !== key) {
          return 'arrow_upward'
        }
        return this.sortAsc ? 'straight' : 'arrow_downward'
      },
      sortBy (key) {
        if (this.sortKey === key) {
          this.sortAsc = !this.sortAsc
        } else {
          this.sortKey = key
          this.sortAsc = true
        }
      },
      groupedRecords (records) {
        const grouped = records.reduce((acc, record) => {
          if (!acc[record.userId]) {
            acc[record.userId] = {
              userId: record.userId,
              firstName: record.firstName,
              lastName: record.lastName,
              email: record.email,
              records: []
            }
          }
          acc[record.userId].records.push(record)
          return acc
        }, {})
        return Object.values(grouped)
      },
      toJSONLocal (date) {
        const local = new Date(date)
        local.setMinutes(date.getMinutes() - date.getTimezoneOffset())
        return local.toJSON().slice(0, 10)
      },
      fetchReport () {
        this.$store.dispatch('splatReport/emailReport', {storeId: this.selectedProgram}).then(response => {
          this.$store.commit('flashSuccess', 'Report sent successfully')
        })
      },
      fetchProgram () {
        this.$store.dispatch('splatReport/fetchReport', {storeId: this.selectedProgram}).then(response => {
          this.groupedUsers = this.groupedRecords(response.data)
        })
      },
      arrayRange (start, stop, step) {
        return Array.from(
          { length: (stop - start) / step + 1 },
          (value, index) => start + index * step
        )
      },
      toggleSelectAllParticipants () {
        this.$nextTick(() => {
          if (this.allParticipants) {
            this.selectedParticipants = []
          } else {
            this.selectedParticipants = this.participants.map(participant => participant.userId)
          }
        })
      },
      validateSendBadgeInEmail () {
        if (this.$refs.badgeEmailForm.validate()) {
          this.sendBadgeMail()
        }
      },
      sendCertificateMail () {
        const badgeId = this.badgeId
        this.loadingSendCertificateMail = true
        this.$store.dispatch('exam/sendCertificateMail', badgeId).then(response => {
          this.$store.commit('flashSuccess', 'Mail sent successfully..')
          this.certificateMailSend = true
          this.loadingSendCertificateMail = false
        })
      },
      sendBadgeMail () {
        const badgeId = this.badgeId
        this.loadingSendBadgeMail = true
        this.$store.dispatch('exam/sendBadgeMail', {emails: this.badgeEmails, badgeId: badgeId}).then(response => {
          this.$store.commit('flashSuccess', 'Mail sent successfully..')
          this.badgeMailSend = true
          this.loadingSendBadgeMail = false
          this.badgeEmailFormValid = false
        })
      },
      formatTime (n) {
        return `${n / 60 ^ 0}:` + n % 60
      },
      async getImage (url) {
        // eslint-disable-next-line no-console
        console.log('Getting')
        try {
          const data = await this.$http({
            url,
            headers: {
              Authorization: 'Bearer ' + this.$auth.token()
              // 'Content-Type': 'multipart/form-data'
            },
            responseType: 'arraybuffer',
            method: 'GET'
          })
          // eslint-disable-next-line no-console
          // console.log('DATA', data)
          // console.log('DATA headers', data.headers)
          // const imageObjectURL = URL.createObjectURL(data)
          let prefix = 'data:' + data.headers['content-type'] + ';base64,'
          let img = Buffer.from(data.data, 'binary').toString('base64')

          return prefix + img
          // this.image = imageObjectURL
          // console.log('Certificates:', response.data)
        } catch (error) {
          console.error('Error uploading image:', error)
        }
      },
      downloadImage (base64String, fileName) {
        const link = document.createElement('a')
        link.href = base64String
        link.download = fileName
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
      },
      async getCertificate (userId, certId) {
        try {
          const response = await this.$http({
            url: `${this.apiUrl}/ws/userservice/user/${userId}/certificate/${certId}`,
            headers: {
              Authorization: 'Bearer ' + this.$auth.token()
              // 'Content-Type': 'multipart/form-data'
            },
            method: 'GET'
          })
          const cert = {
            ...response.data,
            file1Name: response.data.file1,
            file2Name: response.data.file2
          }

          const [file1, file2] = await Promise.all([
            this.getImage(this.apiUrl + response.data.file1),
            this.getImage(this.apiUrl + response.data.file2)
          ])

          cert.file1 = file1
          cert.file2 = file2
          this.frontImg = file1
          this.backImg = file2
        } catch (error) {
          console.error('Error fetching certificates:', error)
        }
      },
      getSelectedUSer (user) {
        this.badgeId = ''
        this.dialog = true
        this.selectedMember = user
        this.selectedUser = {}
        this.frontImg = ''
        this.backImg = ''
        this.badgeEmails = ''

        if (user.badgeId && user.otherCertificate === false) {
          this.badgeId = user.badgeId
          this.$store.dispatch('exam/fetchBadgeFrontImage', { deckId: 62, userId: user.userId }).then(data => {
            let prefix = 'data:' + data.headers['content-type'] + ';base64,'
            let img = Buffer.from(data.data, 'binary').toString('base64')
            this.frontImg = prefix + img
          }).catch(err => {
            console.error('fetchBadgeFrontImageNew', err)
          })
        }

        if (user.badgeId && user.otherCertificate === true) {
          this.getCertificate(user.userId, user.badgeId)
          // this.frontImg = certificateDetails.file1
          // eslint-disable-next-line no-console
          // console.log('certificateDetails', certificateDetails)
        }

        // this.$store.dispatch('complianceProgram/fetchUser', {courseId: 62, username: user.email}).then(response => {
        //   this.selectedUser = response.data
        //   if (this.selectedMember.progress.toLowerCase() === 'badged') {
        //     this.$store.dispatch('course/fetchBadgeData', {deckId: 62, userId: user.userId}).then(badge => {
        //       this.badgeId = badge.data.id
        //       this.$store.dispatch('exam/fetchBadgeFrontImage', { deckId: 62, userId: user.userId }).then(data => {
        //         let prefix = 'data:' + data.headers['content-type'] + ';base64,'
        //         let img = Buffer.from(data.data, 'binary').toString('base64')
        //         this.frontImg = prefix + img
        //       }).catch(err => {
        //         console.error('fetchBadgeFrontImageNew', err)
        //       })
        //     })
        //   }
        // })
      },
      formatDate (date) { return date ? new Date(date).toLocaleDateString() : '' }
    },
    watch: {
      selectedProgram (selectedProgram) {
        this.$store.dispatch('splatReport/fetchReport', {storeId: selectedProgram}).then(response => {
          this.groupedUsers = this.groupedRecords(response.data)
        })
      }
    }
  }
  </script>

<style lang="stylus" scoped>
.v-input__slot .v-input--selection-controls:not(.v-input--hide-details) .v-input__slot {
  margin-bottom: 0!important;
}

@media only screen and (max-width: 480px) {
  .ellipsis {
    max-width: 150px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    display: inline-block;
  }
}
</style>
<style scoped>
td, th {
  padding: 5px;
}
.group-0 {
  background-color: #f9f9f9;
}
.group-1 {
  background-color: #e9e9e9;
}
</style>



// WEBPACK FOOTER //
// src/components/views/manager-actions/Report.vue